export const coverArt = require('./valcapella-and-dwinn.png')
export const redBackground1 = require('./red-background-1.png')
export const redBackground2 = require('./red-background-2.png')
export const redBackground3 = require('./red-background-3.png')
export const redBackground4 = require('./red-background-4.png')
export const redBackground5 = require('./red-background-5.png')
